import axios from './axios';

export default {
  list: () => axios.get('/service_datacenters'),
};
